/* eslint-disable no-restricted-syntax */
export { AUTHENTICATION_SOURCES } from './internal/constants/constants';
import { setupServiceInfo } from '@estee/elc-universal-utils';
import { diContainer, serviceNames } from './service-setup/diContainer';

diContainer.get(serviceNames.sessionManagementService).register();

setupServiceInfo(__serviceInfo__);
